import {useEffect, useState} from "react";
import { Navigate, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { useProfile } from "../Components/Hooks/UserHooks";
import { useSelector, useDispatch } from "react-redux";
import { Role } from "../constants/Role";
import axios from "axios";
import { logoutUser, profileSuccess } from "../store/actions";
import { projectUserSuccess } from "../store/projectUser/actions";
import { setCurrentProjectRole } from "../store/roles";
import { setAuthorization } from "../helpers/api_helper";
import { getAllRoles } from "../store/roles/actions";


const ProtectedAuthorizedRoute = ({children, includedRoles, excludedRoles}) => {
  const { token } = useProfile();
  const navigate = useNavigate();
  const params = useParams()
  const location = useLocation()
  function presentPage() {
    navigate(-1);
  }
  const [nextTick, setNextTick] = useState(null)

  const currentRole = useSelector((state) => state.Roles.currentProjectRole?.role)
 
  useEffect(()=>{
    if (currentRole === undefined && includedRoles && !includedRoles.some(role => currentRole === role)) {
      setNextTick(() => false)
    } else if (currentRole && includedRoles && !includedRoles.some(role => currentRole === role)) {
      setNextTick(() => false)
    } else if (currentRole && excludedRoles && excludedRoles.some(role => currentRole === role)) {
      setNextTick(() => false)
    } else {
      setNextTick(() => true)
    }
  },[includedRoles, currentRole, excludedRoles])
 
  if (!token) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: location } }} />
    );
  }
  
  if ( location.pathname === '/') {
    if ([Role.EPMO_OFFICER,Role.MENTOR].includes(currentRole)) {
      navigate('/projects')
    } else {
      navigate('/project-dashboard')
    }
  }

  if (nextTick!== null && !nextTick) {
    //presentPage()
    const path = '/page-not-found'
    return (
      navigate(path) 
    );
  }
  return <>{(nextTick && children) || <Outlet />}</>

};

export default ProtectedAuthorizedRoute